<template>
  <div :class="{
    'notification-container': true,
    'notification-container-empty': items.length === 0,
  }">
    <transition-group name="ntf" tag="div" mode="out">
      <div v-for="item in items" :key="item.id" :class="'notification p-2'">
        <div class="notification-message">
          <div class="d-flex justify-content-between text-muted">
            <div>
              <img class="notify-icon" :src="getIcon(item.payload.type)" />
              <span> {{ item.payload.category || "" }}</span>
            </div>
            <div>{{ item.payload.date || "" }}</div>
          </div>
          <div class="text-14-semibold py-1">
            {{ item.payload.title || "" }}
          </div>
          <div class="text-muted ">
            {{ item.payload.message || "" }}
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { getIcon } from "../../utils";
export default {
  data() {
    return {
      options: {
        type: "success",
        duration: 2000,
        permanent: false,
      },
      items: [],
      idx: 0,
      typeOfNotify: {
        system: "/assets/image/NLT-INFO/noti-system.svg",
        event: "/assets/image/NLT-INFO/event-icon.svg",
        fire: "/assets/image/NLT-INFO/layers/bctm.svg",
        light: "/assets/image/NLT-INFO/layers/cstm.svg",
        tree: "/assets/image/NLT-INFO/layers/cxdt.svg",
        traffic: "/assets/image/NLT-INFO/layers/dgt.svg",
        gas: "/assets/image/NLT-INFO/layers/gtm.svg",
        speaker: "/assets/image/NLT-INFO/layers/lpt.svg",
        led: "/assets/image/NLT-INFO/layers/mhl.svg",
        buoy: "/assets/image/NLT-INFO/layers/ppl.svg",
        monitor: "/assets/image/NLT-INFO/layers/qtmt.svg",
        bus: "/assets/image/NLT-INFO/layers/xb.svg",
      },
    };
  },
  methods: {
    createUUID() {
      const pattern = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
      return pattern.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    addItem(payload, options) {
      let defaultOptions = {
        duration: this.options.duration,
        permanent: this.options.permanent,
      };
      let itemOptions = Object.assign({}, defaultOptions, options);

      let idx = this.createUUID();

      let newItem = {
        id: idx,
        payload: payload,
        options: itemOptions,
      };
      this.items.push(newItem);
      if (itemOptions.permanent === false) {
        setTimeout(() => {
          this.removeItem(idx);
        }, itemOptions.duration);
      }
    },
    removeItem(uid) {
      this.items = Object.assign(
        [],
        this.items.filter((x) => x.id !== uid)
      );
    },
    removeAll() {
      this.items = [];
    },
    getIcon(type) {
      return getIcon(type);
    },
  },
};
</script>
<style lang="scss">
.ntf-enter {
  opacity: 0;
}

.ntf-leave {
  opacity: 1;
}

.ntf-enter-active {
  animation: slideInRight 0.4s;
}

.ntf-leave-active {
  animation: slideOutRight 0.4s;
}

@-webkit-keyframes slideInRight {
  from {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
    visibility: visible;
  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes slideInRight {
  from {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
    visibility: visible;
  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.slideInRight {
  -webkit-animation-name: slideInRight;
  animation-name: slideInRight;
}

@-webkit-keyframes slideOutRight {
  from {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  to {
    visibility: hidden;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}

@keyframes slideOutRight {
  from {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  to {
    visibility: hidden;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}

.slideOutRight {
  -webkit-animation-name: slideOutRight;
  animation-name: slideOutRight;
}

.notification-container {
  box-sizing: border-box;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 999999;
  padding: 0px 8px;
  /* width: 343px;
  max-height: calc(100% - 30px);
  overflow-x: hidden;
  overflow-y: auto; */
}

.notification {
  width: 343px;
  box-sizing: border-box;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  line-height: 1.2em;
  position: relative;
  margin-top: 8px;
  border-radius: 8px;
  background: #fcfcfc;
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.6),
    0px 0px 2px 0px rgba(0, 0, 0, 0.05), 0px 38px 90px 0px rgba(0, 0, 0, 0.25);
}

.notification .title {
  font-size: 1em;
  line-height: 1.2em;
  font-weight: bold;
  margin: 0 0 5px 0;
}

.notification:hover,
.notification:focus {
  opacity: 1;
  background: #f3f4f6;
}

.notification-enter {
  visibility: hidden;
  transform: translate3d(100%, 0, 0);
}

.notification-enter.notification-enter-active {
  visibility: visible;
  transform: translate3d(0, 0, 0);
  transition: all 0.4s;
}

.notification-leave {
  visibility: visible;
  transform: translate3d(0, 0, 0);
}

.notification-leave.notification-leave-active {
  visibility: hidden;
  transform: translate3d(100%, 0, 0);
  transition: all 0.4s;
}
</style>
